var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col" },
        [
          _c(
            "q-scroll-area",
            { staticStyle: { width: "100%", height: "calc(70vh - 106px)" } },
            [
              _c(
                "q-list",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.items.length > 0,
                      expression: "items.length>0"
                    }
                  ],
                  attrs: { link: "", dense: "", separator: "" }
                },
                [
                  _c("q-list-header", [
                    _vm._v(
                      "Wybierz wyszukiwarkę, która ma zostać wstawiona w edytorze:"
                    )
                  ]),
                  _vm._l(_vm.items, function(item) {
                    return _c(
                      "q-item",
                      {
                        key: item.oid,
                        nativeOn: {
                          click: function($event) {
                            return _vm.itemClick(item)
                          }
                        }
                      },
                      [
                        _c("q-item-side", { attrs: { icon: "view_list" } }),
                        _c("q-item-main", {
                          attrs: {
                            label: item.name + " (" + item.oid + ")",
                            sublabel: item.table
                          }
                        })
                      ],
                      1
                    )
                  })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }